// src/utils/echo.js
// Laravel Echo + Reverb WebSocket initialization

import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher

let echoInstance = null

/**
 * Initialize the Echo instance with the user's auth token.
 * Call this after login when a valid token is available.
 */
export function initEcho(token) {
  if (echoInstance) return echoInstance

  // Realtime (Reverb) is optional per environment. Without a configured app
  // key, `new Echo({ key: undefined })` throws synchronously from pusher-js —
  // which would propagate out of the post-login session save and make a
  // successful login look like a failure. Skip silently when not configured.
  if (!import.meta.env.VITE_REVERB_APP_KEY) {
    return null
  }

  echoInstance = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT,
    wssPort: import.meta.env.VITE_REVERB_PORT,
    forceTLS: import.meta.env.VITE_REVERB_SCHEME === 'https',
    enabledTransports: ['ws', 'wss'],
    // Broadcasting auth is registered under the 'api' prefix but OUTSIDE the v1
    // group (backend: Broadcast::routes), so it lives at /api/broadcasting/auth.
    authEndpoint: import.meta.env.VITE_REVERB_AUTH_ENDPOINT
      || `${import.meta.env.VITE_API_URL || ''}/api/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  })

  return echoInstance
}

/**
 * Get the current Echo instance (may be null if not initialized).
 */
export function getEcho() {
  return echoInstance
}

/**
 * Disconnect the WebSocket and clear the instance.
 * Call this on logout.
 */
export function disconnectEcho() {
  if (echoInstance) {
    echoInstance.disconnect()
    echoInstance = null
  }
}
